const ADDRESS_DOMAIN = 'address'

const ADDRESS_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {},
  new: null
}

export {
  ADDRESS_DOMAIN,
  ADDRESS_STATE
}
